module.exports = "../static/media/banner_short.d50f51cf.png";